(function () {
    window.oneadvanced = window.oneadvanced || {};
    window.oneadvanced.refreshedhubgridblock = window.oneadvanced.refreshedhubgridblock || {};
    window.oneadvanced.refreshedhubgridblock.init = function () {
        //console.log("initializing refreshedhubgridblock js.......");

        var findAllCardGrids = document.querySelectorAll('.refreshedhubgridblock .inner .grid-container .grid-x');

        var handleSetContentHeight = function(element) {
            var cardGrid = element;
            if (!cardGrid || !cardGrid.children.length) return

            var headerContentHeights = []
            var bodyContentHeights = []

            var getCardHeaderContent = cardGrid.querySelectorAll('.header')
            var getCardBodyContent = cardGrid.querySelectorAll('.content')

            for (var child = 0; child < getCardHeaderContent.length; child++) {
                headerContentHeights.push(getCardHeaderContent[child].offsetHeight);
            }
            for (var child = 0; child < getCardBodyContent.length; child++) {
                bodyContentHeights.push(getCardBodyContent[child].offsetHeight);
            }

            if (!headerContentHeights.length || !bodyContentHeights.length) return

            if (window.innerWidth < 640) return

            for (var child = 0; child < getCardHeaderContent.length; child++) {
                getCardHeaderContent[child].style.height = `${Math.max(...headerContentHeights)}px`;
            }

            for (var child = 0; child < getCardBodyContent.length; child++) {
                getCardBodyContent[child].style.height = `${Math.max(...bodyContentHeights)}px`;
            }
        }

        findAllCardGrids.forEach((cardgrid) => {
            handleSetContentHeight(cardgrid);
        })

        window.addEventListener("resize", function () {
            if (window.innerWidth > 640) {
                handleSetContentHeight()
            }
        });
    };

    window.oneadvanced.refreshedhubgridblock.hasLoaded = true;
})();